import React from 'react';
import { Typography, Box } from '@mui/material';

/**
 * Consistent description block shown below each Admin Dashboard tab heading.
 * Provides context about data source, purpose, and recommended actions.
 */
const TabDescription = ({ children }) => (
  <Box sx={{ mb: 3 }}>
    <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
      {children}
    </Typography>
  </Box>
);

export default TabDescription;
